import React, { useEffect, useRef, useState } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import Filter from "../../assets/Icons/filter.png";
import Close from "../../assets/Images/close.png";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import RiskRegisterForm from "./risk-register-form";
import "./risk.css";
import DprHeader from "../layout/dprHeader";
import { useLocation } from "react-router-dom";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";
import ExcelExport from "../../compnenets/commons/xls";
import { toast } from "react-toastify";
import RiskConvertIssueList from "./risk-convert-issue";

export default function Risklist() {
  const location = useLocation();
  const pro = location.state || {};
  const [openFilter, setOpenFilter] = useState(false);
  const onCloseModalFilter = () => setOpenFilter(true);
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(true);
  const [selectedRows, setSelectedRows] = useState([]); // Tracks selected rows
  const [selectAll, setSelectAll] = useState(false);
  const [riskList, setRiskList] = useState([]);
  const [riskFilter, setRiskFilter] = useState({
    ProjectName: "",
    ProductCategory: "",
    Activity_task: "",
    Location: "",
    RiskDueDate: "",
    RiskDescription: "",
    ImpactDescription: "",
    ImpactLevel: 0,
    RiskStatus: "",
    StartDate: "",
    EndDate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRiskFilter((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectAll = () => {
    // if (!selectAll) {
    //     setSelectedRows(data.map((item) => item.id));
    // } else {
    //     setSelectedRows([]);
    // }
    // setSelectAll(!selectAll);
  };

  const getRiskData = async () => {
    const state = JSON.parse(localStorage.getItem("state"));
    setCurrentPage(1);
    let obj = {
      UserID: state.user.user_id,

      //Filters Optional

      ProjectName: "",
      ProductCategory: "",
      Activity_task: openFilter ? riskFilter.Activity_task : "",
      Location: "",
      RiskDueDate: openFilter ? riskFilter.RiskDueDate : "",
      RiskDescription: "",
      ImpactDescription: "",
      ImpactLevel: openFilter ? riskFilter.ImpactLevel : "",
      RiskStatus: openFilter ? riskFilter.RiskStatus : "",
      StartDate: openFilter ? riskFilter.StartDate : "",
      EndDate: openFilter ? riskFilter.EndDate : "",
    };
    const risk = await DPR_API.GetRiskAllocationDetails(obj);
    if (risk.status === 200) {
      setRiskList(risk.RiskList);
      setTimeout(() => {
        setOpenFilter(false);
      }, 1000);
    } else {
      setRiskList([]);
    }
  };

  useEffect(() => {
    getRiskData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(riskList.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = riskList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleConvertClick = async (row) => {
    const state = JSON.parse(localStorage.getItem("state"));
    const obj = {
      RiskID: row.RiskID,
      ProjectID: row.ProjectID,
      TaskID: row.TaskID,
      ProjectName: row.ProjectName,
      ProductCategory: row.ProductCategory,
      Location: row.Location,
      ActivityTask: row.ActivityTask,
      IsRiskintoIssue: "Yes",
      IssueDescription: row.RiskDescription,
      ImpactDescription: row.ImpactDescription,
      ImpactLevel: row.ImpactLevel,
      Probability: row.Probability,

      MitigationStrategy: row.MitigationStrategy,
      IssueStatus: row.RiskStatus,
      AssignedPersonEmail: row.AssignedPersonEmail,
      UserID: state.user.user_id,
    };

    const response = await DPR_API.SaveIssueDetails(obj);
    if (response?.status == 200 || response?.status == 201) {
      toast.success("Risk Converted to issue successfully", {
        autoClose: 2000,
      });
      getRiskData();
    } else {
      toast.error("Unable to convert");
    }
  };

  return (
    <React.Fragment>
      <Breadcrumbs title="Risk Register" menu="" link="Risk Register" />
      <DprHeader project={pro} />
      <div className="pb-5 mt-3">
        <div className="card card-none">
          <div className="card-body" id="risk-register">
            <Tabs>
              <TabList>
                <Tab>Risk Register List</Tab>
                <Tab>Risk Register Form</Tab>
                <Tab>Risk Converted to issue</Tab>
              </TabList>
              <hr />
              <TabPanel>
                <div className="row" style={{ marginRight: 25 }}>
                  <div className="d-flex justify-content-end">
                    <div className="download-icon">
                      <ExcelExport
                        data={riskList?.map((val) => {
                          return {
                            "Project Name": val?.ProjectName,
                            "Product Category": val?.ProductCategory,
                            "Project Location": val?.Location,
                            "Impact Level": val?.ImpactLevel,
                            "Risk Due Date": val?.RiskDueDate,
                            "Risk Status": val?.RiskStatus,
                          };
                        })}
                        fileName="Risk list"
                        sheet="Risk"
                      />
                    </div>
                    <div className="filter-icon mx-2 my-auto">
                      <img
                        className=""
                        onClick={() => {
                          setOpenFilter(true);
                        }}
                        src={Filter}
                        width={20}
                      />
                    </div>
                    <div
                      className="my-auto"
                      onClick={() => {
                        setRiskFilter({
                          ProjectName: "",
                          ProductCategory: "",
                          Activity_task: "",
                          Location: "",
                          RiskDueDate: "",
                          RiskDescription: "",
                          ImpactDescription: "",
                          ImpactLevel: "",
                          RiskStatus: "",
                        });
                        setTimeout(() => {
                          getRiskData();
                          setCurrentPage(1);
                        }, 500);
                      }}
                    >
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: 12,
                          fontWeight: 500,
                          background: "#8add79f7",
                          padding: 5,
                          borderRadius: 12,
                        }}
                      >
                        Clear filters
                      </span>
                    </div>
                  </div>
                </div>
                <div className="table-container">
                  <table className="custom-table">
                    <thead className="table-header">
                      <tr>
                        <th>Sr No</th>
                        <th>Project Name</th>
                        <th>Product Category</th>
                        <th>Project Location</th>
                        <th>Impact Level</th>
                        <th>Risk Due Date</th>
                        <th>Risk Status</th>
                        <th>Created Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.map((row, index) => (
                        <tr key={index}>
                          <td>{index + 1 + (currentPage - 1) * 10}</td>
                          <td id="elps" title={row.ProjectName}>
                            {row.ProjectName}
                          </td>
                          <td id="elps" title={row.ProductCategory}>
                            {row.ProductCategory ? row.ProductCategory : "-"}
                          </td>
                          <td id="elps" title={row.ProjectLocation}>
                            {row.Location ? row.Location : "-"}
                          </td>
                          <td id="elps" title={row.ImpactLevel}>
                            {row.ImpactLevel ? row.ImpactLevel : "-"}
                          </td>
                          <td id="elps" title={row.RiskDueDate}>
                            {row.RiskDueDate
                              ? new Date(row?.RiskDueDate).toLocaleDateString(
                                  "en-GB"
                                )
                              : "-"}
                          </td>
                          <td id="elps" title={row.RiskStatus}>
                            {row.RiskStatus ? row.RiskStatus : "-"}
                          </td>
                          <td>
                            {new Date(row?.CreatedOn).toLocaleDateString(
                              "en-GB"
                            )}
                          </td>
                          {/* <td style={{ cursor: 'pointer' }}>
                                <img src={Add} width={20} onClick={onOpenModal} />
                            </td> */}
                          <td>
                            <button
                              className="btn btn-primary"
                              disabled={new Date(row.RiskDueDate) > new Date()}
                              onClick={(e) => {
                                handleConvertClick(row);
                              }}
                            >
                              Convert to Issue
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div
                    className="pagination"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px 15px",
                    }}
                  >
                    <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      Showing{" "}
                      {Math.min(
                        (currentPage - 1) * rowsPerPage + 1,
                        riskList.length
                      )}{" "}
                      to {Math.min(currentPage * rowsPerPage, riskList.length)}{" "}
                      of {riskList.length} entries
                    </div>

                    <div
                      className="pagination-buttons"
                      style={{
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        gap: "5px",
                      }}
                    >
                      {/* Left Arrow */}
                      <button
                        onClick={() =>
                          handleClick(Math.max(1, currentPage - 1))
                        }
                        disabled={currentPage === 1}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        }}
                      >
                        <img
                          src={leftArrow} // Replace with your actual image path
                          alt="Previous"
                          height="11px"
                          width="7px"
                          style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                        />
                      </button>

                      {/* Page Numbers */}
                      {[...Array(totalPages)].map((_, i) => (
                        <button
                          key={i}
                          onClick={() => handleClick(i + 1)}
                          style={{
                            background:
                              currentPage === i + 1 ? "#00B69B" : "transparent",
                            color: currentPage === i + 1 ? "#fff" : "#000",
                            border: "none",
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          {i + 1}
                        </button>
                      ))}

                      {/* Right Arrow */}
                      <button
                        onClick={() =>
                          handleClick(Math.min(totalPages, currentPage + 1))
                        }
                        disabled={currentPage === totalPages}
                        style={{
                          background: "none",
                          border: "none",
                          cursor:
                            currentPage === totalPages
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <img
                          src={rightArrow} // Replace with your actual image path
                          alt="Next"
                          height="11px"
                          width="7px"
                          style={{
                            opacity: currentPage === totalPages ? 0.5 : 1,
                          }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="row">
                  <div className="col-6">
                    <RiskRegisterForm />
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="row">
                  <div className="col-6">
                    <RiskConvertIssueList />
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
      <Modal open={openFilter} onClose={onCloseModalFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Risk Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenFilter(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    onChange={handleChange}
                    value={riskFilter.StartDate}
                    name="StartDate"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    onChange={handleChange}
                    value={riskFilter.EndDate}
                    name="EndDate"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Activity/Task</label>
                  <input
                    type="text"
                    onChange={handleChange}
                    value={riskFilter.Activity_task}
                    name="Activity_task"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Risk Due date</label>
                  <input
                    type="date"
                    onChange={handleChange}
                    value={riskFilter.RiskDueDate}
                    name="RiskDueDate"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Risk Status</label>
                  <select
                    onChange={handleChange}
                    value={riskFilter.RiskStatus}
                    name="RiskStatus"
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">--Select status--</option>
                    <option value="Open">Open</option>
                    <option value="Close">Close</option>
                  </select>
                </div>
                <div className="col-6">
                  <label className="filter-label">Impact Level</label>
                  <input
                    type="number"
                    onChange={handleChange}
                    value={riskFilter.ImpactLevel}
                    name="ImpactLevel"
                    className="form-control shadow-none"
                  />
                  {/* <select className='filter-label' style={{ width: "100%", height: 31, border: "1px solid #e6e3e3", borderRadius: 4 }}>
                                    <option>Select</option>
                                </select> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Risk</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>ASC</option>
                <option>DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Role"
              value="option1"
            />
            <label for="Role" style={{ fontSize: 14 }}>
              Impact level
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Type"
              value="option1"
            />
            <label for="Type" style={{ fontSize: 14 }}>
              Probability
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Created"
              value="option1"
            />
            <label for="Created" style={{ fontSize: 14 }}>
              Created date
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            onClick={(e) => {
              getRiskData();
            }}
            className="btn btn-primary"
          >
            Filter
          </button>
        </div>
      </Modal>
      <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="allowcate">Assign to Concerned Person</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div>
            <label className="filter-label">Email</label>
            <input
              type="email"
              className="form-control shadow-none"
              placeholder="Email"
            />
          </div>
          <div className="d-flex justify-content-center mt-4">
            <button className="btn btn-primary">Send</button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}
